















































import Vue from "vue";
import { DataTopUp } from "@/models/data/data.model";

export default Vue.extend({
  name: "PurchaseComponent",
  data() {
    return {
      isUserAdmin: true,
      isLoading: false,
      bundles: [
        { value: "00", text: "Select Bundle" },
        { value: "100", text: "100MB - R10" },
        { value: "250", text: "250MB - R15" },
        { value: "500", text: "500MB - R50 " },
        { value: "1000", text: "1GB - R100" },

      ],
      dataPackages: [
        { value: "0", text: "Select Package" },
        { value: "Facebook", text: "Facebook" },
        { value: "Google", text: "Google" },
        { value: "YouTube", text: "YouTube" }
      ],
      model: new DataTopUp(),
    }
  }
})
